import Box from "./Box";
import React from "react";

const HomeCard = ({ children, sx, ...params }) => (
  <Box
    sx={{
      backgroundColor: "white",
      padding: "3px 20px 1px 20px",
      borderRadius: "10px",
      boxShadow: "0px 13px 32px #00000029",
      marginRight: "20px",
      marginTop: "20px",
      ...sx,
    }}
    {...params}
  >
    {children}
  </Box>
);

export default HomeCard;
